import React from "react";
import { Box, IconButton, Typography } from "@mui/joy";
import { Popover } from "@mui/material";
import { useReactionStore, ReactionType } from "../../store/reactionStore";

interface ReactionPickerProps {
  open: boolean;
  anchorEl: HTMLElement | null;
  currentReaction: string | null;
  onSelect: (reactionKey: string) => void;
  onClose: () => void;
  reactions?: ReactionType[];
}

export const ReactionPicker: React.FC<ReactionPickerProps> = ({
  open,
  anchorEl,
  currentReaction,
  onSelect,
  onClose,
  reactions: reactionsProp,
}) => {
  const { reactionTypes } = useReactionStore();
  const reactions = reactionsProp || reactionTypes;

  const handleSelect = (reactionKey: string) => {
    onSelect(reactionKey);
    onClose();
  };

  return (
    <Popover
      data-testid="reaction-picker"
      open={open}
      anchorEl={anchorEl}
      onClose={onClose}
      anchorOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      sx={{
        zIndex: 1300,
      }}
    >
      <Box
        sx={{
          padding: 1,
          display: "flex",
          flexWrap: "wrap",
          gap: 0.5,
          maxWidth: 200,
          justifyContent: "center",
        }}
      >
        {reactions.length === 0 && (
          <Typography level="body-sm" sx={{ padding: 1 }}>
            No reactions available
          </Typography>
        )}
        {reactions.map((reaction) => (
          <IconButton
            key={reaction.key}
            data-testid={`reaction-option-${reaction.key}`}
            onClick={() => handleSelect(reaction.key)}
            aria-label={`React with ${reaction.label}`}
            sx={{
              minWidth: 44,
              minHeight: 44,
              fontSize: "1.5rem",
              backgroundColor:
                currentReaction === reaction.key ? "primary.100" : "transparent",
              "&:hover": {
                transform: "scale(1.05)",
                backgroundColor:
                  currentReaction === reaction.key ? "primary.200" : "background.level1",
              },
            }}
          >
            {reaction.emoji}
          </IconButton>
        ))}
      </Box>
    </Popover>
  );
};
